<template>
  <v-card class="lightning-model-page__trim-card d-flex py-5 align-center" dark>
    <v-card-text class="h-100 d-flex flex-column align-center justify-space-between">
      <v-img :src="noVehicleImage" width="100%" height="auto"></v-img>
      <div class="text-center">
        <p class="mb-2">2025 Ford F-150 Raptor</p>
        <p>$103,140</p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getCDNUrl } from '@/utils'

const props = defineProps<{
  settings: any
}>()

const cdnUrl = getCDNUrl()
const noVehicleImage = `${cdnUrl}/lightning-model-page/admin/assets/no-vehicle-image.png`

const trimCardSettings = computed(() => props.settings?.trimCard || {})

// Width
const trimCardWidth = computed(() => {
  const fontSize = trimCardSettings.value?.width || '330'
  const fontUnit = trimCardSettings.value?.widthUnit || 'px'
  return `${fontSize}${fontUnit}`
})

// Border radius
const trimCardBorderRadius = computed(() => {
  const fontSize = trimCardSettings.value?.borderRadius || '4'
  const fontUnit = trimCardSettings.value?.borderRadiusUnit || 'px'
  return `${fontSize}${fontUnit}`
})
</script>

<style scoped>
.lightning-model-page__trim-card {
  border-radius: v-bind('trimCardBorderRadius');
  width: v-bind('trimCardWidth');
}
</style>
